import section_thiennguyen from '../../assets/images/section-thiennguyen.png';
import React, { useState, useEffect } from 'react';
import charity1 from '../../assets/images/charity-slider/1.png';
import charity2 from '../../assets/images/charity-slider/2.png';
import charity3 from '../../assets/images/charity-slider/3.png';
import charity4 from '../../assets/images/charity-slider/4.png';
import charity5 from '../../assets/images/charity-slider/5.png';
import charity6 from '../../assets/images/charity-slider/6.png';
import charity7 from '../../assets/images/charity-slider/7.png';
import charity8 from '../../assets/images/charity-slider/8.png';

const HeroSection = () => {
  // Commented out for YouTube iframe
  const [currentSlide, setCurrentSlide] = useState(0);

  const charityImages = [
    charity1,
    charity2,
    charity3,
    charity4,
    charity5,
    charity6,
    charity7,
    charity8,
  ];

  // Auto slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % charityImages.length);
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [charityImages.length]);

  return (
    <section className="w-full flex flex-col lg:flex-row gap-2 md:gap-5 mt-2">
      <div className="lg:w-1/2 flex flex-col gap-1">
        <img src={section_thiennguyen} alt="GK88" className="w-2/4 lg:w-2/4 mx-auto" />
        <p className="text-[#242424] font-medium text-justify">
          Quỹ Từ Thiện GK88 là tổ chức thiện nguyện được thành lập từ tháng 7/2023 với sứ mệnh "Kết
          nối yêu thương - Kiến tạo tương lai". Chúng tôi tập trung hỗ trợ trẻ em nghèo, người già
          neo đơn và các hoàn cảnh khó khăn trên khắp mọi miền Tổ Quốc.
          <br />
          Với phương châm "Minh bạch - Thiết thực - Nhân văn", mỗi đóng góp đều sẽ được chuyển thành
          hành động cụ thể, tiếp sức cho những hoàn cảnh kém may mắn ở trên.
        </p>
      </div>
      <div className="lg:w-1/2 mt-4">
        {/* YouTube Video */}
        <div className="relative overflow-hidden rounded-lg shadow-lg">
          <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/o7anCa4AouY?rel=0&modestbranding=1&showinfo=0"
            title="GK88 Charity Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-48 sm:h-56 md:h-64 lg:h-72 rounded-lg"
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          ></iframe>
        </div>

        {/* Charity Images Slider - Commented Out */}
        {/* <div className="relative overflow-hidden rounded-lg shadow-lg">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {charityImages.map((image, index) => (
              <div key={index} className="w-full flex-shrink-0">
                <img
                  src={image}
                  alt={`Hoạt động thiện nguyện ${index + 1}`}
                  className="w-full h-48 sm:h-56 md:h-64 lg:h-72 object-cover"
                />
              </div>
            ))}
          </div>

          <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 flex gap-2">
            {charityImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 rounded-full transition-all duration-200 ${
                  index === currentSlide
                    ? 'bg-[#fe6601] scale-125'
                    : 'bg-white/70 hover:bg-white/90'
                }`}
              />
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default HeroSection;
